import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProvedorDeSessao } from './auth/sessao';
import { ProvedorDeRecado } from './componentes/Recado';
import { SessaoExpirada } from './api/cliente';
import { aplicarTemaGuardado } from './tema';
import { Aplicacao } from './rotas';
import './estilo/tema.css';
import './estilo/botoes.css';

aplicarTemaGuardado();

const fila = new QueryClient({
  defaultOptions: {
    queries: {
      // O acervo muda por ingest, que leva minutos: revalidar a cada foco de
      // janela gastaria chamada sem mudar a tela. Quem precisa de dado fresco
      // (fila de jobs, status de ingest) pede refetchInterval na própria tela.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (tentativas, erro) => {
        // repetir depois do refresh falhar só produz mais 401 e atrasa a volta
        // para a tela de login
        if (erro instanceof SessaoExpirada) return false;
        return tentativas < 1;
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={fila}>
      <ProvedorDeSessao>
        <ProvedorDeRecado>
          <Aplicacao />
        </ProvedorDeRecado>
      </ProvedorDeSessao>
    </QueryClientProvider>
  </StrictMode>,
);
